import * as apiMobilePayments from '@/network/api/mobilePayments.api.js'
import * as accountsApi from '@/network/api/accounts.api.js'

/** requests Accounts Balance
@return {promise} - Accounts Balance request
*/
export const requestAccountsBalances = async (context, payload) => {
    const res = await accountsApi.requestAccountsBalances(payload)
    if (res) {
        const data = res.data.data
        context.commit('SAVE_ACCOUNTS_BALANCES', data)
    }
    return res
}

/** Validate Merchant
@docs https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/GET_internetmobile-paymentsmerchant
@return { promise } - Validate Mobile Payment Merchant Status for a company client
*/
export const getMerchantDetail = async (context, payload) => {
    const res = await apiMobilePayments.getMerchantDetail(payload)

    return res
}

/** Get Merchant Name
@docs https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/GET_restpartnersmerchants%7BmerchantId%7DacceptancePoint%7BacceptancePointId%7D
@return { promise } - Merchant Name
*/
export const getMerchantName = async (context, payload) => {
    const res = await apiMobilePayments.getMerchantName(payload)

    return res
}

/**
@docs https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/POST_internetmobile-paymentspaymerchant
@return {promise} - Create a merchant
*/
export const payToBaiPagaMerchant = async (context, payload) => {
	const res = await apiMobilePayments.payToBaiPagaMerchant(payload)

	return res
}